import React, { useEffect, useRef, useState } from "react";

const BACK_ONLINE_MS = 3000;

const COPY = {
    en: {
        offline: "You are offline. Some features may not work until your connection returns.",
        online: "Back online.",
    },
    es: {
        offline:
            "Sin conexión. Algunas funciones pueden no funcionar hasta que vuelva la conexión.",
        online: "De nuevo en línea.",
    },
};

const isSpanish = () => {
    try {
        return (window.currentLanguage || localStorage.getItem("mrgCurrentLanguage")) === "es";
    } catch {
        return false;
    }
};

// Global connectivity notice, mounted once in each app shell. `navigator.onLine` only
// reports the device's link state (not whether rcideloreanbe.2viz.io is reachable), so
// this covers the user going offline, not the server dropping connections.
const OfflineToast = () => {
    const [status, setStatus] = useState(() =>
        typeof navigator !== "undefined" && navigator.onLine === false ? "offline" : null
    );
    const timerRef = useRef(null);

    useEffect(() => {
        const handleOffline = () => {
            clearTimeout(timerRef.current);
            setStatus("offline");
        };
        const handleOnline = () => {
            clearTimeout(timerRef.current);
            setStatus("online");
            timerRef.current = setTimeout(() => setStatus(null), BACK_ONLINE_MS);
        };
        window.addEventListener("offline", handleOffline);
        window.addEventListener("online", handleOnline);
        return () => {
            window.removeEventListener("offline", handleOffline);
            window.removeEventListener("online", handleOnline);
            clearTimeout(timerRef.current);
        };
    }, []);

    if (!status) return null;

    const copy = isSpanish() ? COPY.es : COPY.en;
    const isOffline = status === "offline";

    return (
        <div
            role="status"
            aria-live="polite"
            className={`fixed bottom-4 left-1/2 z-[9999999999999999] w-[calc(100%-2rem)] max-w-[24rem] -translate-x-1/2 rounded-lg px-4 py-3 text-center text-sm text-white shadow-lg ${
                isOffline ? "bg-[#0C214D]" : "bg-[#1B7F3B]"
            }`}
        >
            {isOffline ? copy.offline : copy.online}
        </div>
    );
};

export default OfflineToast;
